import * as React from 'react'
import classNames from 'classnames'

import style from './style.scss'

type Props = {
  children: React.ReactNode
  className?: string
}

FieldWrapper.defaultProps = {
  className: '',
}

function FieldWrapper(props: Props) {
  const { children, className } = props
  return (
    <div className={classNames(style.fieldWrapper, className)}>{children}</div>
  )
}

export default FieldWrapper
